import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import WizrText from '../components/WizrText';
import WizrTable from '../components/WizrTable';
import PdfIcon from '../assets/icons/PdfIcon';
import WizrFlexLayout from '../components/WizrFlexLayout';
import { useDispatch } from 'react-redux';
import { useCurrentAppDetailsSelector, useGetTrustforteList } from '../redux/selectors/content';
import { dispatchGetTrustforteList } from '../redux/actions/content';
import { useNavigate } from 'react-router-dom';
import { testAppTool } from '../api/helpers/contents';
import { statusChecker } from "../utils"
import WizrButton from '../components/WizrButton';

const Container = styled.div`
  padding: 24px;
  width: 100%;
`;

const TableContainer = styled(WizrFlexLayout)`
  background: white;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  padding: 24px;
  width: 100%;
`;

const FileNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledTable = styled(WizrTable)`
  width: 100%;
  
  .ant-table {
    background: white;
    border: 1px solid #EAECF0;
  }
  
  .ant-table-wrapper {
    width: 100%;
  }
  
  .ant-table-thead > tr > th {
    background: white;
    border-bottom: 2px solid #EAECF0;
    border-right: 1px solid #EAECF0;
    color: #101828;
    font-weight: 500;
    padding: 12px 24px;
    font-size: 12px;
    line-height: 18px;
  }

  .ant-table-thead > tr > th:first-child {
    border-radius: 0;
  }

  .ant-table-thead > tr > th:last-child {
    border-right: none;
    border-radius: 0;
  }

  .ant-table-tbody > tr > td {
    background: white;
    padding: 16px 24px;
    color: #101828;
    font-size: 14px;
    line-height: 20px;
    border-bottom: 1px solid #EAECF0;
    border-right: 1px solid #EAECF0;
  }

  .ant-table-tbody > tr > td:first-child {
    border-radius: 0;
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: none;
    border-radius: 0;
  }

  .ant-table-tbody > tr:hover > td {
    background: white !important;
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;
    border-radius: 0;
  }
`;

interface TrustforteItem {
  id: string;
  email_address: string;
  file_name: string;
  timestamp: number;
  file_type: string;
  file_id: string;
  app_id: string;
  tenant_id: string;
  template_name: string;
}

const TrustforteList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appDetails = useCurrentAppDetailsSelector();
  const trustforteList = useGetTrustforteList();
  const [loading, setLoading] = useState<{[key: string]: boolean}>({});

  useEffect(() => {
    dispatchGetTrustforteList();
  }, []);

  const handlePreview = async (record: TrustforteItem) => {
    try {
      setLoading({ ...loading, [record.file_id]: true });
      
      const testAppPayload = {
        id: record.id,
        app_id: record.app_id,
        history: [],
        exec_type: "app",
        max_past_messages: appDetails?.memory ? 15 : 0,
        message_params: {
          "{{user_query}}": "",
          "{{Transcript}}": `${record.timestamp}/${record.file_name}`,
          "{{Passport}}": "",
          "{{Degree Certificate}}": "",
          "{{Template type}}": `${record.timestamp}/${record.template_name}`
          
        }
      };

      const response = await testAppTool(testAppPayload);
      const statusResponse = await statusChecker(response?.data?.statusQueryGetUri);
      
      //const parsedResponse = JSON.parse(statusResponse);
     // const outputContent = JSON.parse(parsedResponse?.content);
      
      navigate('/docview', {
        state: {
          appDetails: {
            id: record.id,
            app_id: record.app_id
          },
          parameters: [],
          resultContent: statusResponse?.output || '',
        
        }
      });
    } catch (error) {
      console.error('Error previewing document:', error);
    } finally {
      setLoading({ ...loading, [record.file_id]: false });
    }
  };

  const transformedData = trustforteList?.data?.map((item: TrustforteItem) => ({
    email_id: item.email_address,
    file_name: (
      <FileNameContainer>
        <PdfIcon />
        <span>{item.file_name}</span>
      </FileNameContainer>
    ),
    received_on: new Date(item.timestamp).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }),
    actions: (
      <WizrButton 
        onClick={() => handlePreview(item)}
        disabled={loading[item.file_id]}
        text={loading[item.file_id] ? 'Loading...' : 'Preview'}
      >
        
      </WizrButton>
    ),
    file_type: item.file_type,
    file_id: item.file_id,
    app_id: item.app_id,
    tenant_id: item.tenant_id
  })) || [];

  return (
    <Container>
      <TableContainer>
        <StyledTable
          type="trustforteList"
          dataSource={transformedData}
          pagination={{
            total: transformedData.length,
            pageSize: 10,
            current: 1,
          }}
        />
      </TableContainer>
    </Container>
  );
};

export default TrustforteList; 